<template>
    <el-button @click="clickBtn" type="primary" size="mini" :loading="loading" :disabled="disabled||isDisabled" >{{isDisabled?countDown+'s内不可操作':text}}</el-button>
</template>

<script>
    export default {
        name: "DelayButton",
        props:{
            delay:Number,
            text:String,
            clickFn:Function,
            disabled:Boolean,
            loading:Boolean,
        },
        data(){
            return {
                countDown: this.delay,
                timer:null,
                isDisabled:false,
            }
        },
        methods:{
            startCountDown(){
                this.isDisabled = true;
                this.timer = setInterval(() => {
                    if (this.countDown > 0) {
                        this.countDown--;
                    } else {
                        clearInterval(this.timer);
                        this.isDisabled = false; // 启用按钮
                        this.countDown = this.delay; // 重置倒计时时间
                    }
                }, 1000);
            },
            clickBtn(){
                this.startCountDown();
                if(this.clickFn){
                    this.clickFn();
                }
            }
        }
    }
</script>

<style scoped>

</style>
